import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import PromoBanner from '@wix/da-ds/pkg/PromoBanner';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import OfferBanner from '../OfferBanner';
export const MonetizationStrip = ({ className , deviation  })=>{
    var _deviation_adoptable, _deviation_extended;
    const { t  } = useTranslation();
    const adoptables = useFlag('adoptables');
    if (adoptables && ((_deviation_adoptable = deviation.adoptable) === null || _deviation_adoptable === void 0 ? void 0 : _deviation_adoptable.offers)) {
        return /*#__PURE__*/ React.createElement(OfferBanner, _extends({}, deviation.adoptable.offers));
    }
    const promo = deviation === null || deviation === void 0 ? void 0 : (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.showStageMonetizationPromo;
    if (!promo || ![
        'tier',
        'commission',
        'premium_gallery'
    ].includes(promo) || !deviation.author) {
        return null;
    }
    let biEvid = null;
    let link = '';
    if (promo === 'tier') {
        biEvid = BiEventType.VIEW_SUBSCRIPTION_TAB;
        link = Url.userSubscriptionsPath({
            username: deviation.author.username
        });
    } else if (promo === 'commission') {
        biEvid = BiEventType.VIEW_COMMISSIONS_TAB;
        link = Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.COMMISSIONS);
    } else if (promo === 'premium_gallery') {
        biEvid = BiEventType.VIEW_PREMIUM_GALLERIES_TAB;
        link = Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_FOLDERS);
    }
    return /*#__PURE__*/ React.createElement(PromoBanner, {
        className: className,
        size: "small",
        variant: "subscription",
        icon: /*#__PURE__*/ React.createElement(PromoBadge, {
            badgeType: promo,
            size: 16
        }),
        messageAfterIcon: t(`deviationview.artstage.monetizationStrip.var.${promo}.body`),
        ctaLabel: t(`deviationview.artstage.monetizationStrip.var.${promo}.CTA`),
        ctaHref: link,
        ctaBiData: biEvid ? {
            evid: biEvid,
            typeid: deviation.typeId,
            itemid: deviation.deviationId,
            referral_info: ReferralType.ART_STAGE_PROMOTION
        } : undefined
    });
};
MonetizationStrip.displayName = 'MonetizationStrip';
export default MonetizationStrip;
